// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import ArrowRightOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowRightOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowRightOutlinedSvg
  }));
};

ArrowRightOutlined.displayName = 'ArrowRightOutlined';
export default React.forwardRef(ArrowRightOutlined);